import { sortBy, sortType } from "features/core/models/Table"
import { CompanyID } from "../../../features/core/utils"

export interface farmingRanchesConfig {
    id: number,
    ranch_type: ranchTypes
}

export interface InsuranceFilters {
    insurance_company?: number,
    companies?: any,
    season?: number,
    start_date?: string,
    end_date?:string,
    year?: string,
    finished?: boolean,
    closing_condition?: number,
}

export interface SowingRanchListFilters extends InsuranceFilters {
    page_size?: number,
    query?: string,
    page?: number,
    sort_by?: sortBy,
    sort_type?: sortType,
    resowing?: boolean,
}

export interface FarmingListFilters extends InsuranceFilters {
    page_size?: number,
    query?: string,
    page?: number,
    sort_by?: sortBy,
    sort_type?: sortType,
    resowing?: boolean,
    insurance_farming?: number,
    farming?: number,
    state?: number,
    closing_condition?: number
}

export interface HarvestRanchListFilters extends InsuranceFilters {
   page_size?: number,
   query?: string,
   page?: number,
   sort_by?: sortBy,
   sort_type?: sortType,
   progress?: boolean,
   policy?: number,
   insurance_farming?: number,
   farming?: number,
   state?: number,
   closing_condition?: number
}

export interface SowingRanchListQueryParams extends SowingRanchListFilters {
    insurance_company?: number
}

export interface linkRanchsConfig {
    ranch_id: number,
    link_to: number
}

export type ranchTypes = ranchTypesOptions.harvest | ranchTypesOptions.sowing

export enum ranchTypesOptions {
    harvest = 0,
    sowing = 1
}
export interface sowingDepurationExport {
    sowing_ranch_polygon: boolean,
    sown_ranch_polygon: boolean,
    smooth_resowing_ranch_polygon: boolean,
    resowing_ranch_polygon: boolean,
    format: number,
    sowing_ranch_ids?: string[]   
}
export interface harvestDepurationExport {
    png: string[],
    shp: string[],
    csv: string[],
    geojson: string[]
    harvest_ranch_ids: string[]   
}

export interface addAlertSubscription {
    subscription_type: number,
    user_id: number,
    active: boolean
}
export interface alertSubscriptionItem {
    id: number,
    subscription_type: number,
    active: boolean,
    user: {
        id: number,
        name: string
    }
}

export interface alertsTypes {
    [key: number]: string,
}
export interface parsedAlertsTypes {
    id: string,
    value: string
}

export interface daysToReprocess {
    start: string,
    end: string,
    recalculate_periods: boolean,
    date: string
}
export interface vehiclesToReprocess {
    recalculate_periods: boolean,
    date: string
}

export interface exportHarvestRanchDepurationCsv {
    ranch_id: number,
    deliverable_complete?: boolean,
    telemetry_and_csv?:boolean
}

export interface sowingReprocessData {
    days_to_reprocess: {
        [key: number] : Array<daysToReprocess>
    },
    last_status_update: string,
    vehicles_to_reprocess: {
        [key: number] : vehiclesToReprocess
    }
}

export interface changelogProperties {
    version_types: {
        sowing: number,
        harvest: number
    },
    actions: {
        1: string,
        2: string,
        3: string
    }
}

